import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";

const DialogMinCapacityReached = ({
	dialog, space
}) => {
	return (
        <DialogAlertSuccessNotify
            variant="secondary"
            show={dialog.value}
            toggleShow={dialog.toggle}
            title="Haz alcanzado el aforo mínimo del espacio"
            description={`Tu reserva debe tener al menos ${space.minCapacity} estudiantes.`}
            buttons={
                <CustomButton
                    text="Cerrar"
                    width="150px"
                    onClick={dialog.hide} />
			}/>
	);
}

export default DialogMinCapacityReached;